import React from "react";

const KmeansExtended = () => {

    return (

        <div className="content" >
            <section id="hero">
                <h1>
                KMeans Extended for Abstracted Distance Metrics
                </h1>
                <h3>
                Jason Livingston
                </h3>
            </section>

        
        <div style={{ height: '100%', width: '100%' }}>   
            <iframe
                src="/kmeans_extended.html"
                style={{ border: 'none', height: '1200px', width: '100%' }}
                title="Weighted Averaging Notebook"
            ></iframe>
        </div>
            
        </div>

    );
};

export default KmeansExtended;